import { render } from "./CustomerEditor.vue?vue&type=template&id=5a672f94"
import script from "./CustomerEditor.vue?vue&type=script&lang=js"
export * from "./CustomerEditor.vue?vue&type=script&lang=js"

import "./CustomerEditor.vue?vue&type=style&index=0&id=5a672f94&lang=css"

import exportComponent from "/codebuild/output/src860361777/src/isi_presenter_admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__